/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { first, get } from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@bingads-webui-react/fabric-with-signal';
import { originalActionTextMapper } from '@bingads-webui-campaign-legacy/adextension-actionlink/model/language-type-translator';

export const ResponsiveAdPreview = ({ ad, i18n }) => { // for MMA
  const { LandscapeImageMediaUrl } = ad;
  const convertedFinalUrl = useMemo(() => first(ad.FinalUrls), [ad.FinalUrls]);
  const callToAction = useMemo(() => get(originalActionTextMapper, [ad.CallToActionLanguage, ad.CallToAction]), [ad.CallToActionLanguage, ad.CallToAction]);

  return (
    <Link target="_blank" href={convertedFinalUrl} className="mma-ad-preview-content-container">
      <div className="ad-background">
        <div className="ad-label">{i18n.getString(_TL_('Ad'))}</div>
        <div className="ad-gradient-overlay" />
        {LandscapeImageMediaUrl && <img className="ad-preview-image" src={LandscapeImageMediaUrl} align="left" alt="Ad Preview Image" />}
      </div>
      <div className="mma-text-content-container">
        <div className="mma-short-headline">{ad.Headline}</div>
        <div className="mma-display-url">{convertedFinalUrl}</div>
        <div className="mma-description">{ad.Text}</div>
        {callToAction && <button className="mma-callToAction">{callToAction}</button>}
      </div>
    </Link>
  );
};

ResponsiveAdPreview.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ad: PropTypes.shape({
    FinalUrls: PropTypes.arrayOf(PropTypes.string),
    Headline: PropTypes.string,
    Text: PropTypes.string,
    LandscapeImageMediaUrl: PropTypes.string,
    DisplayUrl: PropTypes.string,
    CallToActionLanguage: PropTypes.string,
    CallToAction: PropTypes.string,
  }),
};

ResponsiveAdPreview.defaultProps = {
  ad: {
    FinalUrls: [],
    Headline: '',
    Text: '',
    LandscapeImageMediaUrl: '',
    DisplayUrl: '',
    CallToActionLanguage: '',
    CallToAction: '',
  },
};
